<template>
  <div class="default-menu">
    <div class="default-menu__header">
      <div class="default-menu__header-top">
        <span class="default-menu__title">Навигация</span>
        <button type="button" class="default-menu__close" @click="$emit('close')">
          <IconComponent name="close" />
        </button>
      </div>
    </div>
    <div class="default-menu__body">
      <CatalogFiltersComponent :is-categories-menu="true" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import CatalogFiltersComponent from "@/views/catalog/components/CatalogFiltersComponent.vue";

export default {
  name: "CategoriesMenu",
  components: { CatalogFiltersComponent, IconComponent },
};
</script>
